import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IPublication } from './publication.types';

@Component({
  selector: 'app-publication',
  templateUrl: './publication.component.html',
  styleUrl: './publication.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PublicationComponent {
  @Input() publication: IPublication;
}
